import { useNavigate } from "react-router-dom"
import { useBattleDeckChallenge } from "@/features/battle/DeckChallengeContext"
import { formatDeckSearchModeLabel } from "@/utils/deckSearch"
import { RANK_NAMES } from "@/constants/guardians"

export default function IncomingDeckChallengeModal() {
  const navigate = useNavigate()
  const { incomingDeckChallenge, declineIncomingDeck } = useBattleDeckChallenge()
  const challenge = incomingDeckChallenge

  if (!challenge) return null

  const accept = () => {
    const params = new URLSearchParams({
      mode: "accept",
      challengeId: challenge.challengeId,
      deckSearchMode: challenge.deckSearchMode,
    })
    if (challenge.colorRank) params.set("colorRank", challenge.colorRank)
    navigate(`/play/deck-builder?${params.toString()}`)
  }

  const deckSize = challenge.deckSize ?? 6

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 p-4">
      <div className="w-full max-w-sm rounded-2xl border border-guardians-accent/30 bg-[#1a1a2e] p-6">
        <h2 className="text-center text-lg font-bold">Вызов колодой</h2>
        <p className="mt-1 text-center text-xs text-guardians-muted">
          {deckSize} карт ·{" "}
          {formatDeckSearchModeLabel(challenge.deckSearchMode, challenge.colorRank)}
        </p>
        {challenge.deckSearchMode === "RANK" && challenge.colorRank ? (
          <p className="mt-2 text-center text-sm text-guardians-accent">
            {RANK_NAMES[challenge.colorRank]}
          </p>
        ) : null}
        <div className="mt-6 flex gap-2">
          <button
            type="button"
            onClick={declineIncomingDeck}
            className="flex-1 rounded-xl border border-white/20 py-2.5 text-sm"
          >
            Отклонить
          </button>
          <button
            type="button"
            onClick={accept}
            className="flex-1 rounded-xl bg-guardians-accent py-2.5 text-sm text-guardians-bg"
          >
            Принять
          </button>
        </div>
      </div>
    </div>
  )
}
